/**
 * The dispute permission gate, kept here rather than beside `install.ts` with
 * the rest of the Reclaim scope config.
 *
 * Bazel deps are package-granular, so a file inside merchant/server is only
 * reachable through `//redo/merchant/server:lib` — and that package already
 * depends on `//redo/onboarding/service` and `//redo/shopify/server`, both of
 * which call `hasDisputeScopes`. Moving this up inverts those edges into a
 * cycle Bazel rejects at analysis time. cron and merchant/app read it too, so
 * five packages spanning the graph depend on this gate.
 *
 * The request list is Reclaim-specific and does live beside the install lambda,
 * in `merchant/server/src/lambda/shopify/reclaim-app-scopes.ts`.
 */
/** Gate: what a merchant must already hold. Widening this revokes access. */
export const REQUIRED_DISPUTE_SCOPES = [
  "write_shopify_payments_dispute_evidences",
  "write_shopify_payments_dispute_file_uploads",
] as const;

/**
 * Granted individually, so the write does not confer it. Request, don't gate.
 */
export const DISPUTE_EVIDENCE_READ_SCOPE =
  "read_shopify_payments_dispute_evidences";

export function hasDisputeScopes(scopes: string[]): boolean {
  return REQUIRED_DISPUTE_SCOPES.every((scope) => scopes.includes(scope));
}
